var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.006 4.81h-.05a2.289 2.289 0 01-.989-.232l-3.785 7.507-4.775-3.24a2.375 2.375 0 01-.864.896c-.36.215-.77.328-1.188.328h-.168l1.98 8.785h9.79l.05-14.044z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.957 18.847h2.287l7.124-7.271a.401.401 0 01.436-.088c.048.02.092.05.128.088l1.205 1.234.604-2.73a2.32 2.32 0 01-1.205-.373 2.39 2.39 0 01-.845-.953l-4.847 3.328-3.785-7.545a2.291 2.291 0 01-1.046.273l-.056 14.037z",
    fill: "#FFB24D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.407 8.846a2.45 2.45 0 00-.367-2.868 2.34 2.34 0 00-1.328-.696 2.313 2.313 0 00-1.47.26c-.45.246-.81.636-1.024 1.11a2.454 2.454 0 00-.166 1.514c.107.51.374.971.76 1.313a2.33 2.33 0 001.378.584h.168c.417 0 .826-.113 1.185-.326.36-.214.659-.522.864-.891zm9.55-4.032h.05a2.283 2.283 0 001.052-.277c.466-.25.837-.653 1.053-1.143a2.45 2.45 0 00.138-1.564 2.413 2.413 0 00-.834-1.318A2.325 2.325 0 0013.964 0l-.007 4.814z",
    fill: "#FF9A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.956 0a2.322 2.322 0 00-1.47.532 2.41 2.41 0 00-.821 1.353 2.45 2.45 0 00.187 1.582 2.378 2.378 0 002.104 1.347V0z",
    fill: "#FFB24D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.74 10.07h.054a2.32 2.32 0 001.308-.406c.388-.265.69-.64.868-1.08a2.45 2.45 0 00.134-1.391 2.423 2.423 0 00-.644-1.232 2.341 2.341 0 00-1.207-.66 2.31 2.31 0 00-1.361.138c-.43.182-.799.49-1.057.886a2.444 2.444 0 00-.143 2.42c.192.39.484.719.845.952a2.32 2.32 0 001.204.372zM15.676 20.412a.39.39 0 01-.22-.07.403.403 0 01-.146-.183.406.406 0 01.08-.442l.847-.87h-2.28v4.75h6.088v-3.185h-4.369z",
    fill: "#FF9A00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17 18.847h-.033v4.015a.74.74 0 00.213.52.715.715 0 00.51.215h9.097v-4.75H4.17z",
    fill: "#FFB24D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.888 19.717L25.136 12.8l-1.204-1.224a.384.384 0 00-.28-.118.39.39 0 00-.284.118l-7.124 7.272-.855.87a.4.4 0 00-.086.44.39.39 0 00.366.253h4.376v10.181c0 .108.042.212.117.289.075.076.176.12.282.12h6.375a.395.395 0 00.283-.12.413.413 0 00.117-.289v-10.18h4.385a.393.393 0 00.22-.07.407.407 0 00.168-.417.41.41 0 00-.107-.208h.003z",
    fill: "#5560FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/Icon-up.d5e2f744.svg";
export { ForwardRef as ReactComponent };